import { render, staticRenderFns } from "./SubGroup.vue?vue&type=template&id=cdf84b00"
import script from "./SubGroup.vue?vue&type=script&lang=js"
export * from "./SubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports